module.exports = __webpack_public_path__ + "img/hx.d139b347.png";